module.exports = __webpack_public_path__ + "img/Maroko.f2fcc3b4.png";